import React from 'react'
import PropTypes from 'prop-types'
import { Query, Mutation } from 'react-apollo'
import { Formik, Form, Field } from 'formik'
import { withRouter } from 'react-router'
import ReactRouterPropTypes from 'react-router-prop-types'
import * as Yup from 'yup'

import { Notification } from '../../Notification/Notification'
import { ModeRedirect } from '../../ModeRouter/ModeRouter'
import Button from '../../Button/Button'
import Input from '../../Form/Input/Input'
import {
  IS_RESET_TOKEN_VALID,
  RESET_PASSWORD
} from './ResetPasswordModal.graphql'
import Error from '../../Error/Error'
import Progress from '../../Progress/Progress'
import { PoweredByToastModal } from '../../PoweredByToastModal/PoweredByToastModal'
import { useAuth } from '../../AuthProvider/AuthProvider'
import { dataByTypename } from '../../../utils/apollo-helpers'
import { passwordSchema } from '../../../utils/form-schemas'

const ResetPasswordModal = ({ onClose, location }) => {
  const search = new URLSearchParams(location.search)
  const resetToken = search.get('resetToken')
  const { authenticate } = useAuth()
  return (
    <PoweredByToastModal header='Reset Password' onClose={onClose}>
      <Query query={IS_RESET_TOKEN_VALID} variables={{ resetToken }}>
        {({ data, error, loading, refetch }) => {
          if (loading) {
            return <Progress eventData={{ category: 'Reset Password' }} />
          }
          if (error) return <Error error={error} retry={refetch} />
          const { isResetTokenValid } = data
          return (
            <Mutation mutation={RESET_PASSWORD}>
              {(reset, { loading: resetLoading, data = {} }) => {
                const { ResetPasswordError } = dataByTypename(
                  data.resetPassword
                )

                if (
                  !isResetTokenValid ||
                  (ResetPasswordError &&
                    ResetPasswordError.code === 'INVALID_TOKEN')
                ) {
                  return (
                    <ModeRedirect mode='forgot' state={{ expired: true }} />
                  )
                }
                return (
                  <Formik
                    initialValues={{ newPassword: '' }}
                    validationSchema={Yup.object().shape({
                      newPassword: passwordSchema
                    })}
                    onSubmit={async ({ newPassword }) => {
                      const input = {
                        variables: {
                          input: {
                            newPassword,
                            resetToken
                          }
                        }
                      }
                      const resp = await reset(input)
                      const { AuthenticationResponse } = dataByTypename(
                        resp.data.resetPassword
                      )
                      if (AuthenticationResponse) {
                        const authenticateInput = {
                          variables: {
                            input: AuthenticationResponse
                          }
                        }
                        await authenticate(authenticateInput)
                        onClose()
                      }
                    }}
                  >
                    {({ isValid }) => (
                      <Form>
                        {ResetPasswordError && (
                          <Notification severity='error'>
                            {ResetPasswordError.message}
                          </Notification>
                        )}
                        <Field
                          autoFocus
                          id='new-password'
                          name='newPassword'
                          type='password'
                          label='new password'
                          component={Input}
                        />
                        <Button
                          type='submit'
                          style='primary'
                          responsive
                          disabled={!isValid}
                          loading={resetLoading}
                        >
                          Change
                        </Button>
                      </Form>
                    )}
                  </Formik>
                )
              }}
            </Mutation>
          )
        }}
      </Query>
    </PoweredByToastModal>
  )
}

ResetPasswordModal.propTypes = {
  onClose: PropTypes.func,
  location: ReactRouterPropTypes.location
}

export default withRouter(ResetPasswordModal)
